import React from "react"
import {Icon} from "semantic-ui-react";
import Radium from "radium";


const styles = {
    input : {
        width: '100%',
        backgroundColor: '#384850',
        padding: '0.5em 1em',
        border: 0,
        color: '#6e7579',
        borderRadius: '4px',
        height: '100%',
        ':hover': {
            textDecoration: 'none'
        },
        ':focus': {
            outline: 'none'
        }
    },
    inputWrapper: {
        height:40,
        width: '100%',
        position:'relative'
    },
    icon: {
        position: 'absolute',
        right: 0,
        top: 10,
        color: '#6e7579'
    }

}


let SidebarSearchInput = ({ ...props }) => {
    return (
        <div style={styles.inputWrapper}>
            <Icon name='search' size="large" style={styles.icon} />
            <input type="text" style={styles.input} placeholder="Rechercher" {...props} />
        </div>
    )
};

export default Radium(SidebarSearchInput)